import React from 'react';
import { LabelDate, Spinner } from '../../../../../components';

type VisitStatsCellProps = {
  lastVisitedAt?: string;
  visitedCount?: number;
  isLoading: boolean;
  hasError: boolean;
  type: 'date' | 'count';
};

export const VisitStatsCell: React.FC<VisitStatsCellProps> = ({
  lastVisitedAt,
  visitedCount,
  isLoading,
  hasError,
  type,
}) => {
  if (isLoading) {
    return (
      <div
        className={
          type === 'date'
            ? 'flex items-center'
            : 'flex items-center justify-center'
        }
      >
        <Spinner size={16} />
      </div>
    );
  }

  if (hasError) {
    return <span className="text-secondary">-</span>;
  }

  if (type === 'date') {
    if (!lastVisitedAt) {
      return <span className="text-secondary">-</span>;
    }
    return <LabelDate date={lastVisitedAt} showTime formatDate="dd/MMM/yyyy" />;
  }

  if (type === 'count') {
    if (visitedCount === undefined) {
      return <span className="text-secondary">-</span>;
    }
    return <span className="text-mainText">{visitedCount}</span>;
  }

  return null;
};
